/**
 * 自定义小浮框方法
 */
"use strict";
angular.module("myPopoverModule", []).
directive("myPopover", ["$templateRequest", "$compile", "$q", function($templateRequest, $compile, $q) {
    return {
        restrict: "A",
        replace: false,
        scope: false,
        link: function(scope, $element, $attrs) {
            var status = {};
            init();
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                status = {
                    templateUrl: $attrs["templateUrl"],
                    id: parseInt(Math.random() * 100000)
                };
                initTemplate().then(function() {
                    initClick();
                });
                initBlur();
                bindScroll();
            }
            /**
             * [bindScroll description] 滚动消除
             * @return {[type]} [description]
             */
            function bindScroll() {
                window.addEventListener("mousewheel", myScroll);
                /**
                 * [myScroll description] 滚动事件
                 * @return {[type]} [description]
                 */
                function myScroll() {
                    destroyChildScope($("#" + status.id));
                }
                scope.$on("$destroy", function() {
                    window.removeEventListener("mousewheel", myScroll);
                });
            }
            /**
             * [description] 初始化失焦
             * @return {[type]} [description]
             */
            function initBlur() {
                $("body").bind("click", myBlur);
                /**
                 * [myBlur description] 失焦事件
                 * @return {[type]} [description]
                 */
                function myBlur(e) {
                    var target = e.target;
                    if ($(target).parents("#" + status.id).length > 0) return;
                    if ($(target).parents("*[my-popover]")[0] !== $element[0] && target !== $element[0]) {
                        destroyChildScope($("#" + status.id))
                    }
                }
                scope.$on("$destroy", function() {
                    $("body").unbind("click", myBlur);
                    $("#" + status.id).remove();
                })
            }
            /**
             * [initTemplate description] 初始化模板
             * @return {[type]} [description]
             */
            function initTemplate() {
                var deffer = $q.defer();
                $templateRequest(status.templateUrl).then(function(data) {
                    status.template = $(data);
                    status.template.attr("id", status.id);
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /**
             * [initClick description] 初始化点击事件
             * @return {[type]} [description]
             */
            function initClick() {
                $element.bind("click", function() {
                    var $prevTemplates = $(".rankLineChart");
                    if ($("#" + status.id).length > 0) {
                        destroyChildScope($("#" + status.id));
                    } else {
                        initTemplate().then(function() {
                            $("body").append(status.template);
                            $compile(status.template)(scope);
                            fixPosition();
                        });
                    }
                })
            }
            /**
             * [destroyChildScope description] 销毁子节点
             * @return {[type]} [description]
             */
            function destroyChildScope($dom) {
                try {
                    $dom.remove();
                } catch (e) {}
            }
            /**
             * [fixPosition description] 修正位置
             * @return {[type]} [description]
             */
            function fixPosition() {
                var elemPosition = $element.offset();
                elemPosition.bottom = window.innerHeight - elemPosition.top;
                var rankLineSize = {
                    width: $("#" + status.id)[0].offsetWidth,
                    height: $("#" + status.id)[0].offsetHeight
                }
                if (elemPosition.top < (rankLineSize.height / 2)) {
                    $("#" + status.id).css({
                        top: 0,
                        opacity: 1
                    });
                } else if (elemPosition.bottom > (rankLineSize.height / 2)) {
                    $("#" + status.id).css({
                        top: elemPosition.top - rankLineSize.height / 2,
                        opacity: 1
                    });
                } else {
                    $("#" + status.id).css({
                        bottom: 0,
                        opacity: 1
                    });
                }
                var left = elemPosition.left - rankLineSize.width;
                left = left > 0 ? left : 0;
                $("#" + status.id).css("left", left);
            }
        }
    }
}]);